import { Button } from "@/components/ui";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export type ReadStatus = "All" | "Unread" | "Read";

export function ReadStatusFilter({
  status,
  onStatusChange,
}: {
  status: ReadStatus;
  onStatusChange: (status: ReadStatus) => void;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="secondary"
          color="foreground"
          rounded="full"
          iconAlignment="end"
          size="md"
          iconName="caretDown"
          children={status}
        />
      </DropdownMenuTrigger>

      <DropdownMenuContent>
        <DropdownMenuItem>
          <Button
            variant="link"
            color="foreground"
            onClick={() => onStatusChange("All")}
            children="All"
          />
        </DropdownMenuItem>
        <DropdownMenuItem>
          <Button
            variant="link"
            color="foreground"
            onClick={() => onStatusChange("Unread")}
            children="Unread"
          />
        </DropdownMenuItem>
        <DropdownMenuItem>
          <Button
            variant="link"
            color="foreground"
            onClick={() => onStatusChange("Read")}
            children="Read"
          />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
